import alexImg from '../assets/img/member-alex.jpg'
import seanImg from '../assets/img/member-sean.jpg'
import jackImg from '../assets/img/member-jack.jpg'
import martinImg from '../assets/img/member-martin.jpg'

const en = {
  trans: {
    header: {
      menu: {
        abilities: 'Our Abilities',
        highLight: 'HighLight',
        confidence: 'Confidence & Security',
        model: 'Business Model',
        roadmap: 'Roadmap',
        team: 'Team',
      },
    },
    footer: {
      follow: 'Follow Us',
      email: {
        placeholder: 'Type your Email',
        submit: 'Submit',
      },
      adminEmail: 'admin@sandbags.io',
      alert: {
        notemail: 'Please enter a valid email address',
        success: 'Thank you!',
      },
    },
    banner: {
      description:
        'Web3 Security Cornerstone and the New Contract Security Defense Paradigm',
    },
    abilities: {
      title: 'Our Abilities',
      icon1: 'Proficient in liquidity arbitrage strategies',
      icon2: 'Develop a new paradigm of contract security defense',
      icon3: 'Develop large-scale concurrent systems',
    },
    highLight: {
      title: 'HighLight',
      boards: {
        1: {
          title: 'Contract Defense Patch',
          content:
            'The first security patch that can fix smart contract vulnerabilities based on audit results.',
        },
        2: {
          title: 'Logic Bug Defense',
          content:
            'The first product to defend against logic flaws among contracts and can protect against risks caused by business design flaws.',
        },
        3: {
          title: 'Malicious Bots Tracking',
          content:
            'The security defense rules with high degrees of security and freedom are iterated based on real and quantifiable data. We have accumulated a large amount of attacking samples and behavioral data by observing markers and analyzing behaviors of malicious bots over a long period of time.',
        },
        4: {
          title: '100% Defense',
          content: 'DeFi Economic (Price Manipulation) Attack Diagram.',
        },
      },
    },
    confidence: {
      title: 'Confidence & Security',
      description: {
        1: "DeFi's journey from prosperity to depression is essentially the journey from abundant liquidity to stagnated liquidity. When <1>issues</1> arise from the financial market itself or its participants, we will see a <1>domino effect</1> in on-chain economy projects.",
        2: "The frequent occurrence of blockchain hacking incidents is <1>reducing</1> users' confidence in on-chain funds' security, which then <1>affects</1> the liquidity of on-chain funds.",
        3: 'SandBags is committed to <1>solving</1> on-chain security issues, <1>enhancing</1> user confidence, and ultimately <1>driving</1> the <1>development</1> and prosperity of Web3 finance.',
      },
    },
    model: {
      title: 'Business Model',
    },
    roadmap: {
      title: 'Roadmap',
    },
    team: {
      title: 'Team',
      members: {
        alex: {
          description:
            'Ethereum Contributor. Specialize in information security, network architecture and data visualization. Alex worked for Alibaba, HikVision, and other companies. Alex currently works as a technical consultant and researcher for several investment institutions.',
          name: 'Alex',
          title: 'CTO',
          avatar: alexImg,
        },
        sean: {
          description:
            'Sean graduated from the University of Melbourne and has 5 years of blockchain management and marketing experience. Sean was core marketing member at Step.app, also involved in early community development of OHM.',
          name: 'Sean',
          title: 'CMO',
          avatar: seanImg,
        },
        jack: {
          description:
            'Graduated from the University of Glasgow, majoring in quantitative finance. Founder of Britannia research, a crypto asset investment consultancy advising crypto native firms and funds on portfolio allocation and treasury management.',
          name: 'Jack',
          title: 'Business Development',
          avatar: jackImg,
        },
        martin: {
          description:
            'Graduated from the University of Southampton, majoring in computer science, with a good technical background, has participated in the incubation and operation of Blockchain GameFi projects, and has deep experience in blockchain marketing.',
          name: 'Martin',
          title: 'Operation',
          avatar: martinImg,
        },
      },
    },
  },
}

export default en
